// ไฟล์: frontend/src/pages/admin/AdminUsersPage.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import AdminSidebar from "../../components/layout/AdminSidebar";
import "./AdminPages.css";

const AdminUsersPage = ({ user }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/users");
      setUsers(response.data.users);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถดึงข้อมูลผู้ใช้ได้ในขณะนี้",
      });
    }
  };

  const handleRoleChange = async (userId, newRole) => {
    try {
      await axios.put("/users/role", { userId, role: newRole });

      // อัพเดตข้อมูลผู้ใช้ในสถานะ
      setUsers((prev) =>
        prev.map((user) =>
          user.id === userId ? { ...user, role: newRole } : user
        )
      );

      Swal.fire({
        icon: "success",
        title: "อัพเดทสถานะสำเร็จ",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error updating user role:", error);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่สามารถอัพเดทสถานะผู้ใช้ได้ในขณะนี้",
      });
    }
  };

  const openUserModal = (user) => {
    setSelectedUser(user);
  };

  const closeUserModal = () => {
    setSelectedUser(null);
  };

  // ฟังก์ชันสำหรับการค้นหา
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // รีเซ็ตหน้าเมื่อมีการค้นหา
  };

  // กรองผู้ใช้ตามคำค้นหา
  const filteredUsers = users.filter(
    (user) =>
      user.fullname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (user.school &&
        user.school.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // คำนวณข้อมูลสำหรับการแบ่งหน้า
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  // เปลี่ยนหน้า
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div className="admin-layout">
        <AdminSidebar user={user} />
        <div className="admin-main">
          <div className="loading-container">
            {/* <div className="loading-spinner">กำลังโหลดข้อมูล...</div> */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <AdminSidebar user={user} />
      <div className="admin-page">
        <div className="admin-content">
          <div className="admin-header">
            <h1 className="admin-title">
              <i className="fas fa-users"></i> จัดการผู้ใช้งาน
            </h1>
            <div className="admin-actions">
              <div className="search-box">
                <i className="fas fa-search"></i>
                <input
                  type="text"
                  placeholder="ค้นหาผู้ใช้..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>

          <div className="admin-card">
            <div className="table container-fluid ">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th style={{ width: "60px" }}>รูป</th>
                    <th>ชื่อผู้ใช้</th>
                    <th>ชื่อ-นามสกุล</th>
                    <th>อีเมล</th>
                    <th>โรงเรียน</th>
                    <th style={{ width: "120px" }}>สถานะ</th>
                    <th style={{ width: "100px" }}>จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((user, index) => (
                      <tr key={user.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>
                          <div className="user-avatar">
                            <img
                              src={
                                user.profile_image
                                  ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${user.profile_image}`
                                  : `https://ui-avatars.com/api/?name=${user.fullname}&background=random`
                              }
                              alt={user.fullname}
                            />
                          </div>
                        </td>
                        <td>{user.username}</td>
                        <td>{user.fullname}</td>
                        <td>{user.email}</td>
                        <td>{user.school || "-"}</td>
                        <td>
                          <select
                            className={`role-select ${
                              user.role === "admin" ? "admin" : "teacher"
                            }`}
                            value={user.role}
                            onChange={(e) =>
                              handleRoleChange(user.id, e.target.value)
                            }
                          >
                            <option value="teacher">ครูผู้สอน</option>
                            <option value="admin">ผู้ดูแลระบบ</option>
                          </select>
                        </td>
                        <td>
                          <div className="table-actions">
                            <button
                              className="action-btn view-btn"
                              onClick={() => openUserModal(user)}
                              title="ดูรายละเอียด"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <Link
                              to={`/teachers/${user.id}`}
                              className="action-btn profile-btn"
                              title="ดูโปรไฟล์"
                            >
                              <i className="fas fa-user"></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        ไม่พบข้อมูลผู้ใช้
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="pagination">
                <button
                  className="pagination-btn"
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <i className="fas fa-chevron-left"></i>
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(
                    (page) =>
                      page === 1 ||
                      page === totalPages ||
                      Math.abs(page - currentPage) <= 1
                  )
                  .map((page, index, array) => (
                    <React.Fragment key={page}>
                      {index > 0 && array[index - 1] !== page - 1 && (
                        <span className="pagination-ellipsis">...</span>
                      )}
                      <button
                        className={`pagination-btn ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => paginate(page)}
                      >
                        {page}
                      </button>
                    </React.Fragment>
                  ))}

                <button
                  className="pagination-btn"
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* User Modal */}
      {selectedUser && (
        <div className="modal-backdrop" onClick={closeUserModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>รายละเอียดผู้ใช้</h2>
              <button className="modal-close" onClick={closeUserModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="user-detail">
                <div className="user-detail-header">
                  <div className="user-detail-avatar">
                    <img
                      src={
                        selectedUser.profile_image
                          ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${selectedUser.profile_image}`
                          : `https://ui-avatars.com/api/?name=${selectedUser.fullname}&background=random&size=200`
                      }
                      alt={selectedUser.fullname}
                    />
                  </div>
                  <div className="user-detail-info">
                    <h3>{selectedUser.fullname}</h3>
                    <p className="user-detail-role">
                      <span className={`role-badge ${selectedUser.role}`}>
                        {selectedUser.role === "admin"
                          ? "ผู้ดูแลระบบ"
                          : "ครูผู้สอน"}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="user-detail-body">
                  <div className="detail-group">
                    <label>ชื่อผู้ใช้:</label>
                    <span>{selectedUser.username}</span>
                  </div>
                  <div className="detail-group">
                    <label>อีเมล:</label>
                    <span>{selectedUser.email}</span>
                  </div>
                  <div className="detail-group">
                    <label>โรงเรียน:</label>
                    <span>{selectedUser.school || "-"}</span>
                  </div>
                  <div className="detail-group">
                    <label>กลุ่มสาระ:</label>
                    <span>{selectedUser.subject_area || "-"}</span>
                  </div>
                  <div className="detail-group">
                    <label>วันที่สมัคร:</label>
                    <span>
                      {new Date(selectedUser.created_at).toLocaleDateString(
                        "th-TH"
                      )}
                    </span>
                  </div>
                  <div className="detail-group">
                    <label>ประวัติ:</label>
                    <span>{selectedUser.bio || "-"}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Link
                to={`/teachers/${selectedUser.id}`}
                className="btn btn-primary"
              >
                <i className="fas fa-user"></i> ดูโปรไฟล์
              </Link>
              <button className="btn btn-light" onClick={closeUserModal}>
                ปิด
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminUsersPage;
